
$(document).ready(function(){
  $(".itg_play").click(function(){
    $('.itg_play_video').css('display','block');
    $('body').addClass('bg_color');
  });
  $(".itg_close").click(function(){
    $('.itg_play_video').css('display','none');
    $('body').removeClass('bg_color');
  });


  $(".itg_play").click(function(){
    var plyframe = $("#video1").attr('data-get');
    $('#video1').attr('src', plyframe);
  });
  $(".itg_close").click(function(){
    var stop = $("#video1").attr('src');
    var splitURL= stop.toString().split("?");
    var dyframe = splitURL[0] + '?autoplay=0';
    $('#video1').attr('src', dyframe);
  });


  $('.itg_main_teb ul li span').on('click', function(){

    $('.itg_main_teb ul li span').removeClass('active');
    $(this).addClass('active');
    var this_itme = $(this).attr('data_tab');

    $('.itg_featured-collection__container').each(function(){
      var loop_item = $(this).attr('data-loop');
      if(loop_item == this_itme){
        $(this).show();
      }else{
        $(this).hide();
      }
    });

   $('.owl-carousel').trigger('refresh.owl.carousel');
  });

});



$(document).ready(function(){
  $('.itg_collection_product.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav: true,
    slideBy: 3,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 20,50 L 65,85 L 70,80 L 30,50  L 70,20 L 65,15 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style=""><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 20,50 L 65,85 L 70,80 L 30,50  L 70,20 L 65,15 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3
      }
    }
  })
});



$(document).ready(function(){
  $('.nav__item--default').hover(function(){
    $('.dropdown__trigger--level-2').removeClass('menu_active')
    $('ul.itg_menu_one.menu.dropdown-child').hide();
    $('li.itg_menu_sub.menu-link').removeClass('submenu_active')
    $('li.menu-link.itg_menu_link').removeClass('submenu_active')
  })
  $("li.menu-link.itg_menu_link ").hover(function(){
    //alert('x');
    $('.dropdown__trigger--level-2').removeClass('menu_active')
    $('ul.itg_menu_one.menu.dropdown-child').hide();
    $('li.menu-link.itg_menu_link').removeClass('submenu_active')
    $(this).addClass('submenu_active')
    $(this).closest('li.menu-link.itg_menu_link').find('ul.itg_menu_one.menu.dropdown-child').show();
    $('.submenu_active .itg_menu_icon').addClass('menu_active')
    $('li.itg_menu_sub.menu-link').removeClass('submenu_active')
  }); 
});

$(document).ready(function(){
  $("li.itg_menu_sub.menu-link").hover(function(){
    $('.itg_sub_menu_icon').removeClass('menu_active')
    //alert('x');
    $('ul.itg_menu_two.menu.dropdown-grandchild').hide();
    $('li.itg_menu_sub.menu-link').removeClass('submenu_active').removeClass('mega_active')
    $(this).closest('.grandchild_avalable').addClass('submenu_active').addClass('mega_active')
    $('.mega_active .itg_sub_menu_icon').addClass('menu_active')
    $(this).closest('li.itg_menu_sub.menu-link').find('ul.itg_menu_two.menu.dropdown-grandchild').show();
  });  
  $(".itg_mobile_nav").click(function(){
    $(this).find('.mobile-nav__trigger--level-2').first().toggleClass('is-expanded')
    if ( $(this).find('.itg_cstm_fourt_lavel').hasClass('fourt_lavel_show')) {  
      $(this).find('.itg_cstm_fourt_lavel').removeClass('fourt_lavel_show')
    }
    else{
      $(this).find('.itg_cstm_fourt_lavel').toggleClass('fourt_lavel_show');  
    }
  });
});



$(document).ready(function(){

  $('.itg_header_icon').click(function() {
  
    var check_class =  $(this).closest('.nav__item').find('.megamenu,.dropdown').hasClass('custom-open');
    var this_ = $(this).closest('.nav__item').find('.megamenu,.dropdown');
    
    if (check_class == true){
      $(this_).removeClass('custom-open');
    } else {
      $('.nav__item').find('.megamenu,.dropdown').removeClass('custom-open');
      $(this_).addClass('custom-open');
    }
    
  });
  
});  

/*-----------------------------------NEW CSS-----------------------------------------*/


// $(document).on("click","#itg_collection_1",function() {
//   //alert('kkk')
//   var target = $('.itg_collection_ans_1');
//   if (target.length) {
//      $('html,body').animate({
//           scrollTop: target.offset().top + -50
//       }, 200);
//       return false;
//    }
// });
// $(document).on("click","#itg_collection_2",function() {
//   //alert('kkk')
//     var target = $('.itg_collection_ans_2');
//   if (target.length) {
//      $('html,body').animate({
//           scrollTop: target.offset().top + -50
//       }, 200);
//       return false;
//    }
// });
// $(document).on("click","#itg_collection_3",function() {
//   //alert('kkk')
//     var target = $('.itg_collection_ans_3');
//   if (target.length) {
//      $('html,body').animate({
//           scrollTop: target.offset().top + -50
//       }, 200);
//       return false;
//    }
// });
// $(document).on("click","#itg_collection_4",function() {
//   //alert('kkk')
//     var target = $('.itg_collection_ans_4');
//   if (target.length) {
//      $('html,body').animate({
//           scrollTop: target.offset().top + -50
//       }, 200);
//       return false;
//    }
// });
// $(document).on("click","#itg_collection_5",function() {
//   //alert('kkk')
//     var target = $('.itg_collection_ans_5');
//   if (target.length) {
//      $('html,body').animate({
//           scrollTop: target.offset().top + -50
//       }, 200);
//       return false;
//    }
// });



